import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    routes: [{ // Main
        path: '/',
        name: 'main',
        component: () =>
            import('../views/main.vue')
    },
    { // Main
        path: '/index',
        component: () =>
            import('../views/main.vue')
    },
    { // 登录
        path: '/login',
        name: 'login',
        component: () =>
            import('../views/login.vue')
    },
    { // SSO认证
        path: '/sso',
        name: 'sso',
        component: () =>
            import('../views/sso.vue')
    },

    { // 用户协议
        path: '/protocol',
        name: 'protocol',
        component: () =>
            import('../views/protocol.vue')
    },

    /*******************************************************/

    { // 登录后未绑定/创建钱包前的过渡页
        path: '/createGateway',
        name: 'createGateway',
        component: () =>
            import('../views/createGateway.vue')
    },
    { // 开通钱包/实名认证
        path: '/createWallet',
        name: 'createWallet',
        component: () =>
            import('../views/createWallet.vue')
    },
    { // 绑定银行卡
        path: '/bindCard',
        name: 'bindCard',
        component: () =>
            import('../views/bindCard.vue')
    },
    { // 绑定钱包
        path: '/bindWallet',
        name: 'bindWallet',
        component: () =>
            import('../views/bindWallet.vue')
    },
    { // 已绑定钱包的实名认证
        path: '/bindWalletVerify',
        name: 'bindWalletVerify',
        component: () =>
            import('../views/bindWalletVerify.vue')
    },

    { // 开通成功
        path: '/success',
        name: 'success',
        component: () =>
            import('../views/success.vue')
    },

    /*******************************************************/


    /*******************************************************/

    { // 开通高级钱包/实名认证
        path: '/createSeniorWallet',
        name: 'createSeniorWallet',
        component: () =>
            import('../views/seniorWallet/createSeniorWallet.vue')
    },
    { // 绑定高级钱包
        path: '/bindSeniorWallet',
        name: 'bindSeniorWallet',
        component: () =>
            import('../views/seniorWallet/bindSeniorWallet.vue')
    },
    { // 电子协议页面（通联）
        path: '/sepp',
        name: 'sepp',
        component: () =>
            import('../views/seniorWallet/sepp.vue')
    },
    { // 交易密码页面
        path: '/setPayPassword',
        name: 'setPayPassword',
        component: () =>
            import('../views/seniorWallet/setPayPassword.vue')
    },
    { // 高级钱包绑定银行卡
        path: '/bindCardSeniorWallet',
        name: 'bindCardSeniorWallet',
        component: () =>
            import('../views/seniorWallet/bindCard.vue')
    },
    { // 高级钱包绑定银行卡-信用卡补充
        path: '/creditCard',
        name: 'creditCard',
        component: () =>
            import('../views/seniorWallet/creditCard.vue')
    }, ,
    { // 收取银行卡预留手机号验证码
        path: '/bindCardSeniorWalletSms',
        name: 'bindCardSeniorWalletSms',
        component: () =>
            import('../views/seniorWallet/bindCardSms.vue')
    },
    { // 开通高级钱包成功
        path: '/createSeniorWalletSuccess',
        name: 'createSeniorWalletSuccess',
        component: () =>
            import('../views/seniorWallet/createSeniorWalletSuccess.vue')
    },
    { // 绑定高级钱包成功
        path: '/bindSeniorWalletSuccess',
        name: 'bindSeniorWalletSuccess',
        component: () =>
            import('../views/seniorWallet/bindSeniorWalletSuccess.vue')
    },
    { // 升级高级钱包成功
        path: '/updateSeniorWalletSuccess',
        name: 'updateSeniorWalletSuccess',
        component: () =>
            import('../views/seniorWallet/updateSeniorWalletSuccess.vue')
    },
    { // 高级钱包的首页
        path: '/seniorWalletMain',
        name: 'seniorWalletMain',
        component: () =>
            import('../views/seniorWallet/main.vue')
    },
    { // 高级钱包-充值
        path: '/seniorWalletRecharge',
        name: 'seniorWalletRecharge',
        component: () =>
            import('../views/seniorWallet/recharge.vue')
    },
    { // 高级钱包-提现
        path: '/seniorWalletWithdraw',
        name: 'seniorWalletWithdraw',
        component: () =>
            import('../views/seniorWallet/withdraw.vue')
    },
    { // 高级钱包-银行卡
        path: '/seniorWalletCard',
        name: 'seniorWalletCard',
        component: () =>
            import('../views/seniorWallet/card.vue')
    },
    { // 高级钱包-我的信息
        path: '/seniorWalletUserInfo',
        name: 'seniorWalletUserInfo',
        component: () =>
            import('../views/seniorWallet/userInfo.vue')
    },
    { // 高级钱包-安全验证码
        path: '/safetyVerification',
        name: 'safetyVerification',
        component: () =>
            import('../views/seniorWallet/safetyVerification.vue')
    },
    { // 高级钱包-充值成功
        path: '/rechargeSuccess',
        name: 'rechargeSuccess',
        component: () =>
            import('../views/seniorWallet/rechargeSuccess.vue')
    },
    { // 高级钱包-提现成功
        path: '/withdrawSuccess',
        name: 'withdrawSuccess',
        component: () =>
            import('../views/seniorWallet/withdrawSuccess.vue')
    },
    { // 高级钱包-交易记录
        path: '/seniorWalletRecord',
        name: 'seniorWalletRecord',
        component: () =>
            import('../views/seniorWallet/record.vue')
    },
    { // 交易记录
        path: '/seniorWalletRecordDetail',
        name: 'seniorWalletRecordDetail',
        component: () =>
            import('../views/seniorWallet/recordDetail.vue')
    },
    { // 行为成功页面
        path: '/resetSecurityTel',
        name: 'resetSecurityTel',
        component: () =>
            import('../views/seniorWallet/resetSecurityTel.vue')
    },
    { // 行为成功页面
        path: '/updatePayPwd',
        name: 'updatePayPwd',
        component: () =>
            import('../views/seniorWallet/updatePayPwd.vue')
    },
    { // 行为成功页面
        path: '/resetPayPwd',
        name: 'resetPayPwd',
        component: () =>
            import('../views/seniorWallet/resetPayPwd.vue')
    },
    // { // 行为成功页面
    //     path: '/actionSuccess',
    //     name: 'actionSuccess',
    //     component: () =>
    //         import ('../views/seniorWallet/actionSuccess.vue')
    // },
    { // 开户行信息
        path: '/bankInfo',
        name: 'bankInfo',
        component: () =>
            import('../views/seniorWallet/bankInfo.vue')
    },
    { // 更新开户行信息
        path: '/updateBankInfo',
        name: 'updateBankInfo',
        component: () =>
            import('../views/seniorWallet/updateBankInfo.vue')
    },
    { // 高级钱包委托代扣协议协议
        path: '/deductContract',
        name: 'deductContract',
        component: () =>
            import('../views/seniorWallet/deductContract.vue')
    },
    { // 高级钱包委托代扣协议协议-通联回跳中转页
        path: '/deductContractSuccess',
        name: 'deductContractSuccess',
        component: () =>
            import('../views/seniorWallet/deductContractSuccess.vue')
    },

    /*******************************************************/

    { // 银行卡
        path: '/card',
        name: 'card',
        component: () =>
            import('../views/card.vue')
    },
    { // 银行卡
        path: '/card/detail',
        name: 'card-detail',
        component: () =>
            import('../views/cardDetail.vue')
    },
    { // 银行卡
        path: '/card/change',
        name: 'change-card',
        component: () =>
            import('../views/changeCard.vue')
    },

    /*******************************************************/

    { // 交易记录
        path: '/record',
        name: 'record',
        component: () =>
            import('../views/record.vue')
    },
    { // 交易记录
        path: '/record/detail',
        name: 'record-detail',
        component: () =>
            import('../views/recordDetail.vue')
    },

    { // 我的信息
        path: '/userInfo',
        name: 'userInfo',
        component: () =>
            import('../views/userInfo.vue')
    },

    /*******************************************************/

    { // 测试页
        path: '/help',
        name: 'help',
        component: () =>
            import('../views/help.vue')
    },
    ]
});


// WEBPACK FOOTER //
// ./src/router/index.js